var map = {
	"./100-mil-book-aus.svg": 210,
	"./100-mil-book-es.svg": 211,
	"./100-mil-book.svg": 212,
	"./3000-outlets-aus.svg": 213,
	"./3000-outlets-es.svg": 214,
	"./3000-outlets.svg": 215,
	"./50-countries-aus.svg": 216,
	"./50-countries-es.svg": 217,
	"./50-countries.svg": 218,
	"./70-mil-authors-aus.svg": 219,
	"./70-mil-authors-es.svg": 220,
	"./70-mil-authors.svg": 221,
	"./Componente 6 – 2.svg": 222,
	"./Componente 7 – 2.svg": 223,
	"./Componente 8 – 2.svg": 224,
	"./Facts-and-figures.png": 225,
	"./Google_Play.svg": 226,
	"./Logo_ESP_BRANCO.png": 227,
	"./Logo_ESP_ROXO.png": 228,
	"./X.png": 229,
	"./a4-white.svg": 230,
	"./a4.svg": 231,
	"./a5-white.svg": 232,
	"./a5.svg": 233,
	"./after-01.png": 234,
	"./after-02.png": 235,
	"./after-03.png": 236,
	"./agbook-logo-editor-load.jpg": 237,
	"./agbook-logo-mobile-2.jpg": 238,
	"./agbook-logo-mobile.png": 135,
	"./agbook-logo.png": 239,
	"./ajustes2.png": 240,
	"./alphagraphics.svg": 241,
	"./amex.svg": 242,
	"./ar_on_you.png": 243,
	"./ar_on_you.svg": 244,
	"./arquivo2.png": 245,
	"./article_shortcut.svg": 246,
	"./assistente-de-ia.png": 247,
	"./audio_file.svg": 248,
	"./audiobook-background.png": 249,
	"./authorfreely_primarylogo.png": 122,
	"./auto_stories.svg": 250,
	"./avaliacao2.png": 251,
	"./background-service-all.png": 252,
	"./background-stores.jpg": 253,
	"./banner_partner_stores.png": 254,
	"./bb.svg": 255,
	"./blogger-round-svgrepo-com.svg": 256,
	"./boleto.svg": 257,
	"./book-1-translation.png": 258,
	"./book-1.png": 259,
	"./book-2.png": 260,
	"./book-3.png": 261,
	"./book-de.png": 262,
	"./book-old.png": 263,
	"./book-type-orange.svg": 264,
	"./book-type-red.svg": 265,
	"./book-type.png": 266,
	"./book-type.svg": 267,
	"./book-upload-icon.svg": 268,
	"./book.png": 269,
	"./bookmark_heart.svg": 270,
	"./bottom-background.png": 271,
	"./bradesco.svg": 272,
	"./brand-tiktok-svgrepo-com.svg": 273,
	"./card-icon-1.svg": 274,
	"./card-icon-2.svg": 275,
	"./card-icon-3.svg": 276,
	"./card-icon-4.svg": 277,
	"./card.svg": 278,
	"./chevron-right-black.svg": 279,
	"./chevron-right.svg": 280,
	"./close.svg": 281,
	"./clube-icon-decorator.png": 282,
	"./completed-purchase-book-aus.png": 283,
	"./completed-purchase-book.png": 284,
	"./congratulations-aus.png": 285,
	"./congratulations-de.png": 286,
	"./correcoes2.png": 287,
	"./cover-revision.png": 288,
	"./creditcard.png": 289,
	"./cta-desktop-en.png": 290,
	"./cta-desktop-red.png": 291,
	"./cta-desktop.png": 292,
	"./cta-desktop_de.jpg": 293,
	"./cta-desktop_es.jpg": 294,
	"./cta-mobile-en.png": 295,
	"./cta-mobile-red.png": 296,
	"./cta-mobile.png": 297,
	"./cta-mobile_de.png": 298,
	"./cta-mobile_es.jpg": 299,
	"./dictionary.svg": 300,
	"./diners.svg": 301,
	"./divulgacao2.png": 302,
	"./edit_document.png": 303,
	"./edit_document.svg": 304,
	"./emoji_language.svg": 305,
	"./emotional-analysis_background.png": 306,
	"./epub-conversion-background.png": 307,
	"./epub3-type.png": 308,
	"./esboco.png": 309,
	"./esboco.svg": 310,
	"./facebook-share-pink.svg": 311,
	"./facebook.svg": 312,
	"./facebook2.png": 313,
	"./file-read.png": 314,
	"./first-circle.svg": 315,
	"./format_align_justify.svg": 316,
	"./format_textdirection_r_to_l.svg": 317,
	"./frete-gratis.png": 318,
	"./globe_book.svg": 319,
	"./hand-intelligent.png": 320,
	"./happy-man-using-his-tablet-home-couch_1.png": 321,
	"./happy-man-using-his-tablet-home-couch_2.png": 322,
	"./happy-man-using-his-tablet-home-couch_3.png": 323,
	"./happy-man-using-his-tablet-home-couch_4.png": 324,
	"./headphones.svg": 325,
	"./heart_plus.svg": 326,
	"./hero-background-mobile.png": 327,
	"./hero-background.png": 328,
	"./hero-book-image.png": 329,
	"./hipercard.svg": 330,
	"./icon-a4.svg": 331,
	"./icon-a5.svg": 332,
	"./icon-add.svg": 333,
	"./icon-amazon.svg": 334,
	"./icon-americanas.svg": 335,
	"./icon-apple.svg": 336,
	"./icon-arrow-down-grey.svg": 337,
	"./icon-arrow-down-purple-orange.svg": 338,
	"./icon-arrow-down-purple-white.svg": 339,
	"./icon-arrow-down-purple.svg": 340,
	"./icon-arrow-left-pagination.svg": 341,
	"./icon-arrow-right-orange.svg": 342,
	"./icon-arrow-right-pagination.svg": 343,
	"./icon-arrow-right-pink.svg": 344,
	"./icon-arrow-right-white.svg": 345,
	"./icon-book-grey.svg": 346,
	"./icon-book-orange.svg": 347,
	"./icon-book-purple.svg": 348,
	"./icon-book-white.svg": 349,
	"./icon-burger-purple.svg": 350,
	"./icon-burger-white.svg": 351,
	"./icon-camera.svg": 352,
	"./icon-cart-grey.svg": 353,
	"./icon-cart-white.svg": 354,
	"./icon-chat-orange.svg": 355,
	"./icon-chat-red.svg": 356,
	"./icon-chat.svg": 357,
	"./icon-check-green.svg": 358,
	"./icon-check-pink.svg": 359,
	"./icon-check-red.svg": 360,
	"./icon-check-white.svg": 361,
	"./icon-chevron_left-orange.svg": 362,
	"./icon-chevron_left-red.svg": 363,
	"./icon-chevron_left.svg": 364,
	"./icon-chevron_right.svg": 365,
	"./icon-close-quote.svg": 366,
	"./icon-cross-purple.svg": 367,
	"./icon-cross-red.svg": 368,
	"./icon-cross-white.svg": 369,
	"./icon-donthave.svg": 370,
	"./icon-download.svg": 371,
	"./icon-ebook-orange.svg": 372,
	"./icon-ebook.svg": 373,
	"./icon-epub.svg": 374,
	"./icon-estantevirtual.svg": 375,
	"./icon-exit-aila-editor.svg": 376,
	"./icon-export.svg": 377,
	"./icon-external.svg": 378,
	"./icon-facebook-purple.svg": 379,
	"./icon-feature-detail.svg": 380,
	"./icon-full-cover.svg": 381,
	"./icon-globe.png": 382,
	"./icon-googleplay.svg": 383,
	"./icon-has.svg": 384,
	"./icon-hasnt.svg": 385,
	"./icon-have.svg": 386,
	"./icon-header-aila-editor.svg": 387,
	"./icon-image-gallery.svg": 388,
	"./icon-image-upload.svg": 389,
	"./icon-livrariacultura.svg": 390,
	"./icon-logo-blog-white.svg": 391,
	"./icon-lp-1-orange.svg": 392,
	"./icon-lp-1-red.svg": 393,
	"./icon-lp-1.svg": 394,
	"./icon-lp-2-orange.svg": 395,
	"./icon-lp-2-red.svg": 396,
	"./icon-lp-2.svg": 397,
	"./icon-lp-3-red.svg": 398,
	"./icon-lp-3.svg": 399,
	"./icon-mercadolivre.svg": 400,
	"./icon-mini-book-orange.svg": 401,
	"./icon-mini-book.svg": 402,
	"./icon-money-orange.svg": 403,
	"./icon-money-purple.svg": 404,
	"./icon-open-chart-orange.svg": 405,
	"./icon-open-chart.svg": 406,
	"./icon-open-quote.svg": 407,
	"./icon-person-grey.svg": 408,
	"./icon-person-white.svg": 409,
	"./icon-play-two.svg": 410,
	"./icon-play.svg": 411,
	"./icon-pocket.svg": 412,
	"./icon-print-orange.svg": 413,
	"./icon-print.svg": 414,
	"./icon-profile-orange.svg": 415,
	"./icon-profile-red.svg": 416,
	"./icon-profile.svg": 417,
	"./icon-quadrado.svg": 418,
	"./icon-questionmark-orange.svg": 419,
	"./icon-questionmark-red.svg": 420,
	"./icon-questionmark.svg": 421,
	"./icon-rakuten.svg": 422,
	"./icon-search-purple-orange.svg": 423,
	"./icon-search-purple.svg": 424,
	"./icon-select-arrow.svg": 425,
	"./icon-separated-cover.svg": 426,
	"./icon-seu-livro-red.png": 427,
	"./icon-seu-livro.png": 428,
	"./icon-speak-orange.svg": 429,
	"./icon-speak-purple.svg": 430,
	"./icon-submarino.svg": 431,
	"./icon-trash-can.svg": 432,
	"./icon-trash.svg": 433,
	"./icon-tu-libro.png": 434,
	"./icon-twitter-purple.svg": 435,
	"./icon-upload-white.svg": 436,
	"./icon-upload.svg": 437,
	"./icon_linkedin.svg": 438,
	"./icons8-check.gif": 439,
	"./idioma-33.png": 440,
	"./img-footer-es.svg": 441,
	"./img-footer.svg": 442,
	"./img-footer_de.jpg": 443,
	"./img2-footer-aus.svg": 444,
	"./img2-footer-es.svg": 445,
	"./img2-footer.svg": 446,
	"./info-orange.svg": 447,
	"./info-pink.svg": 448,
	"./info-red.svg": 449,
	"./info.svg": 450,
	"./info1.jpg": 451,
	"./info2.jpg": 452,
	"./info3.jpg": 453,
	"./instagram-share-pink.svg": 454,
	"./instagram.svg": 455,
	"./instagram3.png": 456,
	"./itau.svg": 457,
	"./kloobr.png": 458,
	"./language-translate.svg": 459,
	"./laptop-cda.png": 460,
	"./library_music.svg": 461,
	"./linkedin.svg": 462,
	"./lock.svg": 463,
	"./logo-amazon-color.png": 464,
	"./logo-amazon.png": 465,
	"./logo-americanas-color.png": 466,
	"./logo-americanas.png": 467,
	"./logo-apple-color.png": 468,
	"./logo-apple.png": 469,
	"./logo-authorfreely-mobile.png": 123,
	"./logo-cda-mobile.svg": 470,
	"./logo-cda.svg": 471,
	"./logo-club-de-autores.png": 472,
	"./logo-clube-de-autores-share.png": 473,
	"./logo-clube-de-autores-share.svg": 474,
	"./logo-clube-de-autores.svg": 475,
	"./logo-cultura-color.png": 476,
	"./logo-cultura.png": 477,
	"./logo-estante-color.png": 478,
	"./logo-estante.png": 479,
	"./logo-google-color.png": 480,
	"./logo-google.png": 481,
	"./logo-literary-highways.png": 482,
	"./logo-mercado-color.png": 483,
	"./logo-mercado.png": 484,
	"./logo-rakuten-color.png": 485,
	"./logo-rakuten.png": 486,
	"./logo-submarino-color.png": 487,
	"./logo-submarino.png": 488,
	"./lp-banner-a-desktop.png": 489,
	"./lp-banner-a-mobile.png": 490,
	"./lp-banner-b-desktop-red.png": 491,
	"./lp-banner-b-desktop.png": 492,
	"./lp-banner-b-mobile-red.png": 493,
	"./lp-banner-b-mobile.png": 494,
	"./mastercard.svg": 495,
	"./medium-shot-excited-woman-with-laptop-2.png": 496,
	"./medium-shot-excited-woman-with-laptop-mini-1.png": 497,
	"./medium-shot-excited-woman-with-laptop-mini-2.png": 498,
	"./medium-shot-excited-woman-with-laptop-mini-3.png": 499,
	"./medium-shot-excited-woman-with-laptop.png": 500,
	"./metadata.png": 501,
	"./mood_heart.svg": 502,
	"./new-icon-facebook.svg": 503,
	"./new-icon-linkedin.svg": 504,
	"./new-icon-twitter.svg": 505,
	"./norton.svg": 506,
	"./nota-final2.png": 507,
	"./pdf.png": 508,
	"./pix.png": 509,
	"./play_circle.svg": 510,
	"./pocket-white.svg": 511,
	"./pocket.svg": 512,
	"./preco2.png": 513,
	"./privacidade2.png": 514,
	"./psychology.svg": 515,
	"./publico2.png": 516,
	"./publish-book.png": 517,
	"./publish-book_agbook-2.png": 518,
	"./publish-book_agbook.png": 519,
	"./publish-book_en.png": 520,
	"./publish-book_es.png": 521,
	"./quadrado-white.svg": 522,
	"./quadrado.svg": 523,
	"./record_voice_over.svg": 524,
	"./relatorio2.png": 525,
	"./responsabilidade.png": 526,
	"./room-circle.svg": 527,
	"./second-circle.svg": 528,
	"./sentiment_stressed.svg": 529,
	"./services-footer-1.png": 530,
	"./services-footer-2.png": 531,
	"./services-footer-3.png": 532,
	"./services-footer-4.png": 533,
	"./services-footer-5.png": 534,
	"./slider-arrow-left-grey.svg": 535,
	"./slider-arrow-right-grey.svg": 536,
	"./spellcheck.svg": 537,
	"./stars_1-orange.svg": 538,
	"./stars_1-red.svg": 539,
	"./stars_1.svg": 540,
	"./stars_2-orange.svg": 541,
	"./stars_2-red.svg": 542,
	"./stars_2.svg": 543,
	"./stars_3-orange.svg": 544,
	"./stars_3-red.svg": 545,
	"./stars_3.svg": 546,
	"./stars_4-orange.svg": 547,
	"./stars_4-red.svg": 548,
	"./stars_4.svg": 549,
	"./stars_5-orange.svg": 550,
	"./stars_5-red.svg": 551,
	"./stars_5.svg": 552,
	"./stars_sprint.png": 553,
	"./stars_sprint.svg": 554,
	"./stars_sprint_orange.svg": 555,
	"./stars_sprint_red.svg": 556,
	"./third-circle.svg": 557,
	"./thumb-mini_de.jpg": 558,
	"./twitter-share-pink.svg": 559,
	"./twitter.svg": 560,
	"./user-account-en.png": 561,
	"./user-book.png": 562,
	"./visa.svg": 563,
	"./whatsapp.svg": 564,
	"./word-file-icon.svg": 565,
	"./word-message-aus.svg": 566,
	"./word-message-es.svg": 567,
	"./word-message.svg": 568,
	"./wordpress.svg": 569,
	"./your-book-mini-aus.png": 570,
	"./youtube-play-svgrepo-com.svg": 571
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;